import { requestAsync } from 'redux-query';

import endpoints from 'consts/endpoints';

export type activationOrdersV2ParamsType = {
  contract_number?: string;
  status?: string;
  company_id?: string;
  page?: number;
  limit?: number | null;
  order_id?: string;
  ao_type?: string;
  _sort?: null | string;
};

export type activationOrdersV2Type = {
  params?: activationOrdersV2ParamsType;
  errorCallback?: Function;
  successCallback?: Function;
  resultKey?: string;
};

export default ({
  params,
  errorCallback,
  successCallback,
  resultKey = 'activationOrdersDataV2',
}: activationOrdersV2Type) =>
  requestAsync({
    url: endpoints.getActivationOrdersUrlV2(params),
    transform: (response) => ({
      [resultKey]: response,
    }),
    queryKey: endpoints.getActivationOrdersUrlV2(params),
    options: {
      headers: {
        Accept: 'application/json',
      },
    },
    meta: {
      authToken: true,
      errorCallback,
      successCallback,
    },
    update: {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      [resultKey]: (_prevEntities, newEntities) => newEntities,
    },
  });
